import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "dialog-popup"
}
const _hoisted_2 = { class: "dialog-title" }
const _hoisted_3 = { class: "d-flex justify-content-end mt-2" }

import { ref } from 'vue'
import MsButton from '../general/buttons/MsButton.vue'
import { ButtonSize } from '@/utilities/enums'


export default /*@__PURE__*/_defineComponent({
  __name: 'InlineConfirmationDialog',
  props: {
  title: {
    type: String,
    default: 'Confirm Action'
  },
  show: {
    type: Boolean,
    default: false
  },
  showComment: {
    type: Boolean,
    default: true
  }
},
  emits: ['confirm', 'cancel'],
  setup(__props, { emit: __emit }) {



const emit = __emit

const comments = ref('')

function confirm() {
  emit('confirm', comments.value)
  comments.value = ''
}

function cancel() {
  emit('cancel')
  comments.value = ''
}

return (_ctx: any,_cache: any) => {
  return (__props.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h5", _hoisted_2, _toDisplayString(__props.title), 1),
        (__props.showComment)
          ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
              key: 0,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((comments).value = $event)),
              class: "form-control comment-area",
              placeholder: "Leave a comment for reference",
              rows: "3"
            }, null, 512)), [
              [_vModelText, comments.value]
            ])
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(MsButton, {
            class: "me-2",
            buttonSize: _unref(ButtonSize).Small,
            buttonFont: "NKT-P2-medium",
            onClick: confirm
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode(" Confirm "),
              _createElementVNode("i", { class: "ms-check-icon fe fe-check" }, null, -1)
            ])),
            _: 1
          }, 8, ["buttonSize"]),
          _createVNode(MsButton, {
            buttonSize: _unref(ButtonSize).Small,
            buttonFont: "NKT-P2",
            onClick: cancel
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createTextVNode(" Cancel "),
              _createElementVNode("span", { class: "ms-x-icon fe fe-x" }, null, -1)
            ])),
            _: 1
          }, 8, ["buttonSize"])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})